/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IconRef } from './IconRef';
import {
    IconRefFromJSON,
    IconRefFromJSONTyped,
    IconRefToJSON,
} from './IconRef';

/**
 * 
 * @export
 * @interface RecentItem
 */
export interface RecentItem {
    /**
     * 
     * @type {string}
     * @memberof RecentItem
     */
    label: string;
    /**
     * 
     * @type {IconRef}
     * @memberof RecentItem
     */
    icon?: IconRef;
    /**
     * 
     * @type {string}
     * @memberof RecentItem
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof RecentItem
     */
    title?: string;
}

/**
 * Check if a given object implements the RecentItem interface.
 */
export function instanceOfRecentItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;

    return isInstance;
}

export function RecentItemFromJSON(json: any): RecentItem {
    return RecentItemFromJSONTyped(json, false);
}

export function RecentItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecentItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': json['label'],
        'icon': !exists(json, 'icon') ? undefined : IconRefFromJSON(json['icon']),
        'url': !exists(json, 'url') ? undefined : json['url'],
        'title': !exists(json, 'title') ? undefined : json['title'],
    };
}

export function RecentItemToJSON(value?: RecentItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'icon': IconRefToJSON(value.icon),
        'url': value.url,
        'title': value.title,
    };
}

